<div #modalRoot class="modal fade" id="noDeviceReassignModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" *ngIf="package">
      <div class="modal-header">
        <i class="action_reassign_icon"></i>
        <h4 class="modal-title fw-bold">{{ 'PACKAGES.ASSIGN_PACKAGE' | translate }}</h4>
      </div>
      <div class="modal-body text-center">
        <p>{{ 'COMMON.REASSIGN.REASSIGN_PACKAGE' | translate:{ x: package.id } }}</p>
      </div>

      <div class="reassign_container">

        <!-- Base entity owner: distributor or head office (read-only) -->
        <div class="reassign_container_row" *ngIf="baseOwner">
          <div>{{ ('ENTITY_TYPE.' + baseOwner.entityTypeId) | translate }}</div>
          <div>{{ baseOwner.name }}</div>
        </div>


        <!-- Package type (read-only) -->
        <div class="reassign_container_row" *ngIf="package?.packageType">
          <div>{{ 'COMMON.REASSIGN.REASSIGN_TYPE' | translate }}</div>
          <div>{{ package!.packageType.name }}</div>
        </div>
        <!-- Entity selector using BVS -->
        <div class="reassign_container_row">
          <div>{{ 'COMMON.REASSIGN.REASSIGN_ENTITY' | translate }}</div>
          <div>
            <app-basic-virtual-scroll
              *ngIf="filteredEntities.length > 0"
              [typeData]="'reassignNoDevice'"
              [customTreeNode]="filteredEntities"
              (callback)="onBvsCallback($event)">
            </app-basic-virtual-scroll>
            <small *ngIf="filteredEntities.length === 0" class="text-muted">{{ 'COMMON.NO_RESULTS' | translate }}</small>
          </div>
        </div>

        <div *ngIf="error" class="reassign_container_row single-package-message">{{ error }}</div>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
          {{ 'COMMON.REASSIGN.REASSIGN_CANCEL' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-dark"
          [disabled]="!targetEntityId || loading || checkingDestination || blockedByDeadStandalone"
          (click)="confirm()">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
          {{ 'COMMON.REASSIGN.REASSIGN_CONFIRM' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Same wording and layout as the general reassign flow, with ids of their own. The destination
     already had a standalone package that is now dead: a distributor cannot hand it another one,
     an admin is warned and may go ahead. -->
<hbo-confirmation-modal [id]="warnBlockedId" [hideConfirm]="true" (confirm)="onWarningAcknowledged()"
  (cancel)="onWarningAcknowledged()" [head]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP'"
  [extendedMessage]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_EXTENDED'" [message]="'COMMON.EMPTY_STRING'"
  [cancelText]="'COMMON.UNDERSTAND'"></hbo-confirmation-modal>

<hbo-confirmation-modal [id]="warnAdminId" [hideConfirm]="true" (confirm)="onWarningAcknowledged()"
  (cancel)="onWarningAcknowledged()" [head]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP'"
  [message]="'COMMON.REASSIGN.SOME_LICENSE_SAME_GROUP_ADMIN_NO_DEVICE'"
  [cancelText]="'COMMON.UNDERSTAND'"></hbo-confirmation-modal>
